<template>
  <div class="prod-gallery-row-mobile native_slider">
    <button
      data-scroll_left_by="-1"
      aria-label="Previous"
      class="native_slider-btn native_slider-btn-prev">
      Prev
    </button>
    <div class="native_slider-lg prod-gallery-row m-0" v-if="galleryImages.length > 0">
      <slot name="favorites"/>
      <div class="native_slider-li prod-gallery-thumb" v-for="navigationThumbs in galleryImagesSorted"
           :key="navigationThumbs.id">
        <a :href="mainImage['large']" class="image-popup-vertical-fit">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="navigationThumbs['large']"
                   class="prod-gallery-thumb-img"
                   @click="mainImage = navigationThumbs"
                   loading="eager"
                   :alt="productCodeId"/>
            </div>
          </div>
        </a>
      </div>
    </div>
    <button
      data-scroll_left_by="1"
      aria-label="Next"
      class="native_slider-btn native_slider-btn-next">
      Next
    </button>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvProductGalleryMobile',
  props: {
    productId: {
      type: Number
    },
    mainImageFirst: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [productMixin],
  data () {
    return {
      productCodeId: null,
      mainImage: null,
      galleryImages: [{
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }]
    }
  },
  computed: {
    selectedAttributeId () {
      return store.getters.getSelectedAttributeId
    },
    selectedProductCodeId () {
      return store.getters.getSelectedProductCodeId
    },
    galleryImagesSorted () {
      if (!this.mainImageFirst) {
        return this.galleryImages
      }
      const images = this.galleryImages
      return images.sort(function (a, b) { return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0 })
    }
  },
  watch: {
    selectedProductCodeId (val) {
      this.productCodeId = val
      this.setUpGalleryUpdate()
    },
    selectedAttributeId (attributeId) {
      const productCode = this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
      this.setUpGalleryUpdate(productCode.productCodeId)
    }
  },
  mounted () {
    this.setProductCodeId()
    this.setUpGalleryUpdate()
  },
  methods: {
    setUpGalleryUpdate (codeId = null) {
      this.productCodeImages(codeId)
      this.setMainImage()
    },
    setProductCodeId () {
      if (this.selectedProductCodeId) {
        this.productCodeId = this.selectedProductCodeId
      } else {
        this.productCodeId = parseInt(Object.keys(this.productData.images)[0])
      }
    },
    productCodeImages (codeId = null) {
      if (!(codeId === null)) {
        this.galleryImages = this.productData.images[parseInt(codeId)]
      } else if (!(this.productCodeId === null)) {
        this.galleryImages = this.productData.images[this.productCodeId]
      }
    },
    setMainImage () {
      this.mainImage = this.galleryImages.find(image => image.is_main === '1')
    }
  }
}
</script>
